import { useEffect, useState } from "react";
import { Col, Image, Row, Container, Card } from "react-bootstrap";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { api, url } from "../axios/api";
import { Link } from "react-router-dom";
import { logo } from "../static";
import { FaGavel } from "react-icons/fa";

const AreasPratica = () => {
    const [areas, setAreas] = useState([]);

    const getAreas = async () => {
        try {
            // Seguindo a sua lógica de API dinâmica
            const res = await api.get(`/AreaPratica.php?action=listAll`);
            setAreas(res.data.data || []);
        } catch (error) {
            console.error("Erro ao carregar áreas de prática:", error);
        }
    }

    useEffect(() => {
        getAreas();
    }, []);

    return (
        <>
            <Navbar />

            <main style={{ backgroundColor: "#fdfcf9" }}>
                {/* --- HEADER DA PÁGINA --- */}
                <section 
                    className="py-5 position-relative overflow-hidden" 
                    style={{ backgroundColor: "#2c2219", color: "#f4f1ea", minHeight: "35vh", display: "flex", alignItems: "center" }}
                >
                    <div 
                        className="position-absolute w-100 h-100"
                        style={{
                            top: 0, left: 0,
                            backgroundImage: `url(${logo})`,
                            backgroundSize: '40px 40px',
                            backgroundRepeat: 'repeat',
                            opacity: 0.03,
                            zIndex: 1
                        }}
                    />
                    <Container className="position-relative text-center" style={{ zIndex: 2 }}>
                        <h6 className="text-uppercase fw-bold mb-2" style={{ color: "#c5a47e", letterSpacing: "3px" }}>Expertise Jurídica</h6>
                        <h1 className="display-4 fw-bold" style={{ fontFamily: "'Playfair Display', serif" }}>Áreas de Prática</h1>
                        <p className="lead mx-auto opacity-75 mt-3" style={{ maxWidth: "700px" }}>
                            Soluções jurídicas especializadas para desafios complexos, com rigor técnico e visão estratégica.
                        </p>
                    </Container>
                </section>

                {/* --- LISTAGEM DE ÁREAS --- */}
                <Container className="py-5 my-5">
                    <Row className="g-4">
                        {areas.length > 0 ? (
                            areas.map((area, index) => (
                                <Col lg={4} md={6} key={area.id || index}>
                                    <Card className="h-100 border-0 shadow-sm rounded-0 card-area-pratica">
                                        <div className="overflow-hidden" style={{ height: "200px" }}>
                                            <Card.Img 
                                                variant="top" 
                                                src={url + "/uploads/" + area.foto} 
                                                className="rounded-0 h-100 w-100 object-fit-cover transition-zoom"
                                            />
                                        </div>
                                        <Card.Body className="d-flex flex-column p-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <FaGavel style={{ color: "#c5a47e", marginRight: "10px" }} />
                                                <h5 className="fw-bold mb-0" style={{ color: "#2c2219", fontFamily: "'Playfair Display', serif" }}>
                                                    {area.titulo}
                                                </h5>
                                            </div>
                                            
                                            <Card.Text className="text-muted small mb-4" style={{ textAlign: "justify", flexGrow: 1 }}>
                                                {area.descricao_curta || area.descricao?.substring(0, 120) + "..."}
                                            </Card.Text>

                                            <Link 
                                                to="/contactos" 
                                                className="btn btn-dark rounded-0 py-2 fw-bold text-uppercase w-100 shadow-sm btn-consultoria"
                                                style={{ letterSpacing: "1px", fontSize: "0.85rem" }}
                                            >
                                                Agendar Consultoria
                                            </Link>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))
                        ) : (
                            <Col className="text-center py-5">
                                <div className="spinner-border text-warning" role="status">
                                    <span className="visually-hidden">Carregando...</span>
                                </div>
                            </Col>
                        )}
                    </Row>
                </Container>
            </main>

            <Footer />

            <style>{`
                .card-area-pratica {
                    transition: all 0.4s ease;
                    border-bottom: 3px solid transparent !important;
                }
                .card-area-pratica:hover {
                    transform: translateY(-10px);
                    box-shadow: 0 15px 35px rgba(44, 34, 25, 0.1) !important;
                    border-bottom: 3px solid #c5a47e !important;
                }
                .transition-zoom {
                    transition: transform 0.6s ease;
                }
                .card-area-pratica:hover .transition-zoom {
                    transform: scale(1.1);
                }
                .btn-consultoria {
                    background-color: #2c2219;
                    border: 1px solid #2c2219;
                    transition: all 0.3s ease;
                }
                .btn-consultoria:hover {
                    background-color: #c5a47e;
                    border-color: #c5a47e;
                    color: white;
                }
            `}</style>
        </>
    );
};

export default AreasPratica;